import {PropertyMarker} from "./PropertyMarker";
import {simplePropertyMarkerTemplateIcon} from "../templates/SimplePropertyMarkerTemplate/SimplePropertyMarkerTemplateIcon";


export class SimplePropertyMarker extends PropertyMarker {
    /**
     * function that returns the template for the property marker icon
     * @returns {string}
     */
    templateIcon() {
        return simplePropertyMarkerTemplateIcon(this);
    }

    /**
     * function that returns the template for the property marker card
     * @returns {string}
     */
    templateCard() {
        return null;
    }
}
